/**
 * @fileoverview GET handler for the "/engagement/api/segment_cohorts/billing_history" endpoint
 */
/**
 * @owner @Appboy/user-targeting
 */
import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { engagementApiSegmentCohortsBillingHistory } from "./constants";
import type { EngagementApiSegmentCohortsBillingHistoryResult } from "./types";

export const getEngagementApiSegmentCohortsBillingHistory = reactQueryFetcherAdapter(
  engagementApiSegmentCohortsBillingHistory,
  (
    signal: AbortSignal,
    startDate: string,
    endDate: string
  ): Promise<EngagementApiSegmentCohortsBillingHistoryResult> => {
    return fetch(
      `/engagement/api/segment_cohorts/billing_history?start_date=${startDate}&end_date=${endDate}`,
      "GET",
      {},
      { signal }
    );
  }
);
